import { sensorsAPI } from '@/api'

export async function getSensorData(sensor)
{
  const response = await sensorsAPI.get(`/?sensor_id=${sensor}`);
  return response.data;
}
